module.exports = __webpack_public_path__ + "img/woman-torso-back.76fa6868.png";